// extracted by mini-css-extract-plugin
export var tooltipContent = "klv-tooltip-module--tooltipContent--51a44";
export var triggerSpan = "klv-tooltip-module--triggerSpan--ef19f";